/* PARTNERS */

import BasicLayout from '@/views/layouts/basic.vue';
import partnersOverview from '@/views/partners/list.vue';
import partnersDetails from '@/views/partners/details.vue';
import partnerAddresses from '@/views/partners/addresses/list.vue';
import partnerAddressDetails from '@/views/partners/addresses/details.vue';
import partnerAgreements from '@/views/partners/agreements/list.vue';
import partnersAgreementDetails from '@/views/partners/agreements/details.vue';
import partnerContacts from '@/views/partners/contacts/list.vue';
import partnerContactDetails from '@/views/partners/contacts/details.vue';
import partnerUsers from '@/views/partners/users/list.vue';
import partnerUserDetails from '@/views/partners/users/details.vue';
import partnerQuotes from '@/views/partners/quotes/list.vue';
import partnerOrders from '@/views/partners/orders/list.vue';
import partnerInvoicesOverview from '@/views/partners/invoices/list.vue';
import partnerCustomersOverview from '@/views/partners/customers/list.vue';
import partnerCustomersDetails from '@/views/partners/customers/details.vue';

/* ROUTER
-------------------------------------------------------------- */
export default {
  path: 'partners',
  name: 'partners',
  meta: {title: 'Partners'},
  redirect: '/partners/overzicht',
  component: BasicLayout,
  children: [
    // Overview routes
    {
      path: 'overzicht',
      name: 'partners.overview',
      meta: {title: 'Partners'},
      component: partnersOverview,
      children: [
        {
          path: ':status',
          name: 'partners.overview.status',
          meta: {title: 'Partners'},
          component: partnersOverview,
        },
        {
          path: ':type',
          name: 'partners.overview.type',
          meta: {title: 'Partners'},
          component: partnersOverview,
        },
      ],
    },
    // Partner info page
    {
      path: 'toevoegen',
      name: 'partners.add',
      meta: {title: 'Partner'},
      component: partnersDetails,
    },
    {
      path: ':pid/wijzig',
      name: 'partners.edit',
      meta: {title: 'Partner'},
      component: partnersDetails,
    },
    {
      path: ':pid/overeenkomsten',
      name: 'partners.agreements.list',
      meta: {title: 'Overeenkomsten'},
      component: partnerAgreements,
    },
    {
      path: ':pid/overeenkomst/:paid/wijzig',
      name: 'partners.agreements.edit',
      meta: {title: 'Overeenkomst'},
      component: partnersAgreementDetails,
    },
    {
      path: ':pid/overeenkomsten/toevoegen',
      name: 'partners.agreements.add',
      meta: {title: 'Nieuwe overeenkomst'},
      component: partnersAgreementDetails,
    },
    // Address list
    {
      path: ':pid/adressen',
      name: 'partners.addresses.list',
      meta: {title: 'Adressen klant'},
      component: partnerAddresses,
    },
    {
      path: ':pid/addresses/toevoegen',
      name: 'partner.address.add',
      meta: {title: 'Klantadres toevoegen'},
      component: partnerAddressDetails,
    },
    {
      path: ':pid/adressen/:addressId/wijzigen',
      name: 'partner.address.edit',
      meta: {title: 'Klantadres toevoegen'},
      component: partnerAddressDetails,
    },
    // Contact add
    {
      path: ':pid/contacten/toevoegen',
      name: 'partner.contact.add',
      meta: {title: 'Contact toevoegen'},
      component: partnerContactDetails,
    },
    // Contacts list
    {
      path: ':pid/contacten',
      name: 'partners.contacts.list',
      meta: {title: 'Contacten partner'},
      component: partnerContacts,
      children: [
        // Contacts list by status
        {
          path: ':status',
          name: 'partners.contacts.list.status',
          meta: {title: 'Contacten partner'},
          component: partnerContacts,
        },
      ],
    },
    // Contact info/edit page
    {
      path: ':pid/contacten/:contactId/wijzig',
      name: 'partner.contact.edit',
      meta: {title: 'Contact wijzigen'},
      component: partnerContactDetails,
    },
    // User add
    {
      path: ':pid/gebruikers/toevoegen',
      name: 'partner.user.add',
      meta: {title: 'Gebruiker toevoegen'},
      component: partnerUserDetails,
    },
    // Users list
    {
      path: ':pid/gebruikers',
      name: 'partners.users.list',
      meta: {title: 'Gebruikers partner'},
      component: partnerUsers,
      children: [
        {
          path: ':status',
          name: 'partners.users.list.status',
          meta: {title: 'Gebruikers partner'},
          component: partnerUsers,
        },
      ],
    },
    // User info/edit page
    {
      path: ':pid/gebruikers/:userId/wijzig',
      name: 'partner.user.edit',
      meta: {title: 'Gebruiker wijzigen'},
      component: partnerUserDetails,
    },
    // Quotes list
    {
      path: 'offertes/:pid',
      name: 'partners.quotes.list',
      meta: {title: 'Offertes klant'},
      component: partnerQuotes,
    },
    // Orders list
    {
      path: 'orders/:pid',
      name: 'partners.orders.list',
      meta: {title: 'Orders klant'},
      component: partnerOrders,
    },
    // Invoices list
    {
      path: ':pid/facturen',
      name: 'partners.invoices.list',
      meta: {title: 'Klanten'},
      component: partnerInvoicesOverview,
    },
    // Customer add
    {
      path: ':pid/klanten/toevoegen',
      name: 'partners.customers.add',
      meta: {title: 'Klant'},
      component: partnerCustomersDetails,
    },
    // Customers list
    {
      path: ':pid/klanten',
      name: 'partners.customers.list',
      meta: {title: 'Klanten'},
      component: partnerCustomersOverview,
      children: [
        // Customers list by status
        {
          path: ':status',
          name: 'partners.customers.list.status',
          meta: {title: 'Klanten'},
          component: partnerCustomersOverview,
        },
      ],
    },
    // Customer info/edit page
    {
      path: ':pid/klanten/:id/wijzigen',
      name: 'partners.customers.edit',
      meta: {title: 'Klant'},
      component: partnerCustomersDetails,
    },
  ],
};
